import { render } from "./RoutingLists.vue?vue&type=template&id=5bb1cc3d"
import script from "./RoutingLists.vue?vue&type=script&lang=js"
export * from "./RoutingLists.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__